import React, { useEffect } from 'react'
import { Routes, Route, Link, Navigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { useInstitution } from '../../contexts/InstitutionContext'
import './TeacherApp.css'

const TeacherApp = () => {
  const { currentUser, logout } = useAuth()
  const { institution, theme, applyTheme, institutionName } = useInstitution()

  // Apply institution theming
  useEffect(() => {
    applyTheme()
  }, [theme, applyTheme])

  const handleLogout = async () => {
    try {
      await logout()
    } catch (error) {
      console.error('Error logging out:', error)
    }
  }

  return (
    <div className="teacher-platform">
      <header className="teacher-header">
        <div className="teacher-nav">
          <div className="teacher-brand">
            {institution?.logo_url && (
              <img 
                src={institution.logo_url} 
                alt={institutionName} 
                className="institution-logo"
              />
            )}
            <h1>{institutionName} Teacher Dashboard</h1>
          </div>
          <nav className="teacher-navigation">
            <Link to="/teacher/dashboard" className="nav-link">Dashboard</Link>
            <Link to="/teacher/students" className="nav-link">Students</Link>
            <Link to="/teacher/analytics" className="nav-link">Analytics</Link>
            <Link to="/teacher/projects" className="nav-link">Projects</Link>
            <Link to="/teacher/reports" className="nav-link">Reports</Link>
          </nav>
        </div>
        <div className="teacher-user-info">
          <span>Welcome, {currentUser?.displayName || currentUser?.email}</span>
          <button onClick={handleLogout} className="logout-btn">Logout</button>
        </div>
      </header>

      <main className="teacher-main">
        <Routes>
          <Route path="/dashboard" element={<TeacherDashboard />} />
          <Route path="/students" element={<StudentsView />} />
          <Route path="/analytics" element={<AnalyticsView />} />
          <Route path="/projects" element={<ProjectsView />} />
          <Route path="/reports" element={<ReportsView />} />
          <Route path="/" element={<Navigate to="/teacher/dashboard" />} />
        </Routes>
      </main>
    </div>
  )
}

const TeacherDashboard = () => (
  <div className="teacher-dashboard">
    <h2>Teacher Dashboard</h2>
    <div className="dashboard-grid">
      <div className="dashboard-card">
        <h3>Student Activity</h3>
        <p>Real-time student activity feed</p>
        <div className="coming-soon">Coming Soon</div>
      </div>
      <div className="dashboard-card">
        <h3>Recent Projects</h3>
        <p>Latest student projects and submissions</p>
        <div className="coming-soon">Coming Soon</div>
      </div>
      <div className="dashboard-card">
        <h3>Usage Statistics</h3>
        <p>Platform usage analytics and metrics</p>
        <div className="coming-soon">Coming Soon</div>
      </div>
      <div className="dashboard-card">
        <h3>Performance Metrics</h3>
        <p>Student success rates and completion times</p>
        <div className="coming-soon">Coming Soon</div>
      </div>
    </div>
  </div>
)

const StudentsView = () => (
  <div className="students-view">
    <h2>Students Management</h2>
    <p>Manage and monitor student accounts and activities</p>
    <div className="coming-soon-large">
      <h3>Features Coming Soon:</h3>
      <ul>
        <li>Student list and profiles</li>
        <li>Activity monitoring</li>
        <li>Progress tracking</li>
        <li>Account management</li>
      </ul>
    </div>
  </div>
)

const AnalyticsView = () => (
  <div className="analytics-view">
    <h2>Analytics & Insights</h2>
    <p>Detailed analytics and performance insights</p>
    <div className="coming-soon-large">
      <h3>Features Coming Soon:</h3>
      <ul>
        <li>Usage charts and graphs</li>
        <li>Student performance metrics</li>
        <li>Resource utilization</li>
        <li>Custom reports</li>
      </ul>
    </div>
  </div>
)

const ProjectsView = () => (
  <div className="projects-view">
    <h2>Student Projects</h2>
    <p>View and manage all student projects</p>
    <div className="coming-soon-large">
      <h3>Features Coming Soon:</h3>
      <ul>
        <li>Project gallery</li>
        <li>Project details and files</li>
        <li>Download capabilities</li>
        <li>Project statistics</li>
      </ul>
    </div>
  </div>
)

const ReportsView = () => (
  <div className="reports-view">
    <h2>Reports & Exports</h2>
    <p>Generate and export detailed reports</p>
    <div className="coming-soon-large">
      <h3>Features Coming Soon:</h3>
      <ul>
        <li>Automated report generation</li>
        <li>CSV/PDF exports</li>
        <li>Custom report builder</li>
        <li>Scheduled reports</li>
      </ul>
    </div>
  </div>
)

export default TeacherApp 